import { connect } from 'react-redux';
import { closeModal } from '../redux/actions/modalActions';
var modalDecorator = function modalDecorator(_ref) {
  var name = _ref.name;
  var mapStateToProps = function mapStateToProps(state) {
    if (state.modal.hasOwnProperty(name)) {
      var _state$modal$name = state.modal[name],
        isOpen = _state$modal$name.isOpen,
        modalProps = _state$modal$name.modalProps;
      return Object.assign({
        isOpen: isOpen
      }, modalProps);
    }
    return {
      isOpen: false
    };
  };
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      close: function close() {
        return dispatch(closeModal(name));
      }
    };
  };
  return function (WrappedComponent) {
    return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
  };
};
export default modalDecorator;